/**
 * Chat widget view for the autopop pane/screen.
 */
import springyView from '../../tools/SpringyView.js';

const autoView = Object.create(springyView);

autoView.events = {
    keydown: 'trapFocus'
};

/**
 * Wrapper for springyView.init in case we need extra functionality.
 * @param {Object} config Config data.
 * @param {chatWidget} config.model Widget object for this view.
 */
autoView.initialize = function(config) {
    config.$el = window.$('#autoload');

    this.init(config);
};
/**
 * Get the name/image data for dept or op who is online.
 * @return {Object}
 */
autoView._getOnlineProfile = function({ botname = '', botimage = '' }) {
    if (this.model.get('autoload_default')) {
        if (botname !== '') {
            return {
                name: botname,
                image: botimage,
                color: this.model.get('color_head')
            };
        }
        const online_rule = this.model.get('online_rule');
        if (online_rule.opId > 0 || online_rule.coopId !== '') {
            return {
                name: '',
                image: '',
                color: ''
            };
        }
        const dept = online_rule.getFirstDept();
        return {
            name: dept.name || '',
            image: dept.image || '',
            color: dept.color || ''
        };
    }
    return {
        name: this.model.get('autoload_name'),
        image: this.model.get('autoload_image'),
        color: this.model.get('color_head')
    };
};
/**
 * Hide this view.
 */
autoView.hideView = function() {
    this.$el.addClass('hidden');
};
/**
 * Show this view and set focus as appopriate
 */
autoView.showView = function() {
    this.$el.removeClass('hidden');
    // do not set focus on this view.
};
/**
 * Is this pane currently showing.
 * @returns {Boolean}
 */
autoView.isShowing = function() {
    return !this.$el[0].classList.contains('hidden');
};
/**
 * Render the view
 * @param {Object} bot info
 * @return {autoView}
 */
autoView.render = function(bot = {}) {
    // clear out existing content, events, etc.
    this.$el.empty();

    // render the template and put it in the dom.
    const templateData = {
        profile: this._getOnlineProfile(bot),
        autoload_head: this.model.get('autoload_head'),
        autoload_text: this.model.get('autoload_text'),
        autoload_yes: this.model.get('autoload_yes'),
        autoload_no: this.model.get('autoload_no'),
        cal_autoload: this.model.get('cal_autoload'),
        cal_url: this.model.get('cal_url'),
        cal_text: this.model.get('cal_text')
    };
    this.$el.html(this.templateEng.render('pane_autoload.njk', templateData));

    // convert any link's target (for customizable text)
    const target = this.model.offlineLinkTarget();
    this.$el[0].querySelectorAll('a').forEach((el) => {
        if (!el.getAttribute('target')) {
            el.setAttribute('target', target);
        }
    });

    return this;
};

export default autoView;
